import React from "react";
import { Link } from "react-router-dom";
// reactstrap components
import {
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
  InputGroup,
  Navbar,
  Nav,
  Container,
  Media
} from "reactstrap";

import { getSessionCookie, setObjectCookie_Generic } from "services/session.js";

import routes from "../../routes-concessionaria.jsx";

//Context
import { AlertasContext } from "../../context/AlertasContext.jsx";

//Components
import AlertasVisualizacoes from "../../components/AlertasVisualizacoes/index.jsx";

class AdminNavbar extends React.Component {
  static contextType = AlertasContext;

  constructor(props) {
    super(props);
    this.state = {
      value: '',
      nomeUsuario: getSessionCookie().nome,
      icon: ""
    }
    this.handleEnter = this.handleEnter.bind(this);
  }

  handleEnter = (e) => {
    const { history } = this.props;
    if (e.key === "Enter") {
      if (e.target.value !== "") {
        setObjectCookie_Generic("ordem_servico", e.target.value);
      } else {
        setObjectCookie_Generic("ordem_servico", "*");
      }
      this.state.value = "";
    }
  };

  LogOut = () => {
    const { history } = this.props;

    const { setAlertas, setPermissaoExibirAlerta } = this.context;

    setAlertas([]);
    setPermissaoExibirAlerta(false);

    history.push('/auth/login');
  };

  TrocarSenha = () => {
    const { history } = this.props;
    history.push('/concessionaria/trocarsenha');
  }

  render() {

    var _name_route = this.props.brandText;

    return (
      <>
        <Navbar className="navbar-top navbar-dark" expand="md" id="navbar-main">
          <Container fluid>
            <span class="h4 mb-0 text-white text-uppercase d-none d-lg-inline-block">
              <i className={routes.filter(function (n) { return n.name === _name_route })[0].icon}></i>
              &nbsp;
              {this.props.brandText}
            </span>
            <Nav className="align-items-center d-none d-md-flex" navbar>
              <AlertasVisualizacoes />
              <UncontrolledDropdown nav>
                <DropdownToggle className="p-0" nav>
                  <Media className="align-items-center">
                    <Media className="ml-2 d-none d-lg-block">
                      <span className="mb-0 text-sm font-weight-bold">
                        {this.state.nomeUsuario}
                      </span>
                      &nbsp;
                      <i class="fa fa-chevron-circle-down" aria-hidden="true" />
                    </Media>
                  </Media>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-arrow" right>
                  <DropdownItem className="noti-title" header tag="div">
                    <h6 className="text-overflow m-0">Bem Vindo!</h6>
                  </DropdownItem>
                  <DropdownItem onClick={this.TrocarSenha}>
                    <i className="ni ni-lock-circle-open" />
                    <span>Trocar Senha</span>
                  </DropdownItem>
                  <DropdownItem divider />
                  <DropdownItem onClick={this.LogOut}>
                    <i className="ni ni-user-run" />
                    <span>Logout</span>
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </Nav>
          </Container>
        </Navbar>
      </>
    );
  }
}

export default AdminNavbar;
